import { useListTasksQuery } from '@graphql/generated';

import { TASK_PAGE_SIZE } from './useListTasksFromQuery';

export const useTasks = () => {
  const { data } = useListTasksQuery({
    fetchPolicy: 'cache-and-network',
    variables: {
      before: '',
      first: TASK_PAGE_SIZE,
    },
  });
  const { listTasks } = data || { listTasks: null };
  const { edges } = listTasks || { edges: [], pageInfo: null };
  const tasks = (edges || []).map((item) => item?.node);
  return tasks;
};
